import $ from 'jquery';

export default () => {
  $('[data-arrow-location], [data-arrow-location-mobile]').each((i, el) => {
    const $arrows = $(el).find('.flickity-prev-next-button');
    if ($arrows.length === 0) { return; }
    let center;

    center = $(el).data('arrowLocation');

    if (window.theme.breakpoints.current === 'mobile') {
      center = $(el).data('arrowLocationMobile');
    }

    const $center = $(el).find(center);

    if ($center.length === 0) { return; }

    $arrows.css({
      top: (($center.height() / 2) + $center.position().top),
    });
  });
};